/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import {axiosInstance} from '../axiosInstance'
const getAllOrgApplicationAuthProviders = param => {
    return axiosInstance.post(`/api/gcadmin/v1/organization-application-auth-provider/getAll`,param).then(res => res.data)
}
const createOrgApplicationAuthProvider = (app) => {
    return axiosInstance.post(`/api/gcadmin/v1/organization-application-auth-provider/create`,app).then(res => res.data)
}
const editOrgApplicationAuthProvider = (app) => {
    return axiosInstance.post(`/api/gcadmin/v1/organization-application-auth-provider/update`,app).then(res => res.data)
}
const getOrgAppAuthProviderHistory = param => {
    return axiosInstance.post(`/api/gcadmin/v1/organization-application-auth-provider/get-history`,param).then(res => res.data)
}
const getAllOrgsAppsAuthProvidersByOrgID = param => {
    return axiosInstance.post(`/api/gcadmin/v1/organization-application-auth-provider/getAllByOrganizationID`,param).then(res => res.data)
}
export {
    getAllOrgApplicationAuthProviders,
    createOrgApplicationAuthProvider,
    editOrgApplicationAuthProvider,
    getOrgAppAuthProviderHistory,
    getAllOrgsAppsAuthProvidersByOrgID
}
